import script from "./Table4WorkspaceHermesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./Table4WorkspaceHermesForm.vue?vue&type=script&setup=true&lang=js"

import "./Table4WorkspaceHermesForm.vue?vue&type=style&index=0&id=6167756d&scoped=true&lang=scss"
import "./Table4WorkspaceHermesForm.vue?vue&type=style&index=1&id=6167756d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6167756d"]])

export default __exports__